export default {"src":"/_next/static/media/bco.cc5a1987.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};